<template>
	<div :class="$style.wrapper">
		<a-tooltip
			v-if="!editMode"
			placement="top"
		>
			<template slot="title">
				✏️ Editar
			</template>
			<div
				:class="$style.text"
				@click="toggleEdit"
			>
				{{ value }}
			</div>
		</a-tooltip>

		<a-tooltip
			v-else
			placement="top"
		>
			<template slot="title">
				✏️ Modo edición
			</template>
			<div :class="$style.input">
				<input
					ref="input"
					:placeholder="value"
					autofocus
					type="text"
					:size="value.length - 1"
					@blur="toggleEdit"
				>
			</div>
		</a-tooltip>
	</div>
</template>

<script>
export default {
	name: 'GInlineEditor',
	props: {
		value: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			editMode: false

		};
	},
	methods: {
		toggleEdit(event) {
			if (this.editMode) {
				this.$emit('input', event.target.value);
			}

			this.editMode = !this.editMode;

			setTimeout(() => {
				if (this.editMode) this.$refs.input.focus();
			}, 100);
		}
	}
};
</script>

<style lang="scss" module>
	.wrapper, .text, .input{
		display: inline-block;
	}

	.input input{
		border: 0px;
		padding: 0px;
		color: $gray-5;
		font-weight: inherit;
		font-family: inherit;
		//font-size: 16px;
	}
</style>
